import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OrderEntry } from '@spartacus/cart/base/root';
import { ProductMediaComponent } from '../../../../product/product-media/product-media.component';
import { I18nModule, OCC_USER_ID_CURRENT, Product, UserIdService } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { fixProductName } from '../../../../../../core/services/simple-tools';
import { TARGET_TYPE } from '../../../../../../core/models/link.model';
import { map, of } from 'rxjs';
import { ProductPriceModule } from '../../../../product/product-price/product-price.module';
import { CustomItemCounterModule } from '../../../../product/item-counter/item-counter.module';
import { FormGroup, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { NDBSQuickOrderService } from '../../ndbs-quick-order.service';

@Component({
  selector: 'quick-order-product-item',
  standalone: true,
  imports: [
    CommonModule,
    ProductMediaComponent,
    I18nModule,
    RouterModule,
    ProductPriceModule,
    CustomItemCounterModule,
    ReactiveFormsModule,
  ],
  templateUrl: './quick-order-product-item.component.html',
  styleUrl: './quick-order-product-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickOrderProductItemComponent {
  @Input() entry!: OrderEntry;
  @Input() form!: FormGroup;

  fixProductName = fixProductName;
  isLogged$ = this.userIdService.getUserId().pipe(map(userID => userID === OCC_USER_ID_CURRENT));
  targetURL: TARGET_TYPE = TARGET_TYPE.BLANK;

  constructor(
    private userIdService: UserIdService,
    private ndbsQuickOrderService: NDBSQuickOrderService,
  ) {}

  product2Observable(product: Product) {
    return of(product);
  }

  getControl(): UntypedFormControl {
    const id = this.ndbsQuickOrderService.getID(this.entry.product!.code!);
    return this.form.get(id)?.get('qty') as UntypedFormControl;
  }

  removeItem() {
    const id = this.ndbsQuickOrderService.getID(this.entry.product!.code!);
    this.form.get(id)?.get('qty')?.setValue(0);
  }
}
